import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "getting-started"
    }}>{`Getting Started`}</h1>
    <h2 {...{
      "id": "installation"
    }}>{`Installation`}</h2>
    <p>{`Start by installing `}<inlineCode parentName="p">{`react-flexible-sliding-menu`}</inlineCode>{` as a dependency with `}<inlineCode parentName="p">{`npm`}</inlineCode>{` :`}</p>
    <pre><code parentName="pre" {...{}}>{`npm i react-flexible-sliding-menu
`}</code></pre>
    <p>{`or if you are using `}<inlineCode parentName="p">{`yarn`}</inlineCode>{` :`}</p>
    <pre><code parentName="pre" {...{}}>{`yarn add react-flexible-sliding-menu
`}</code></pre>
    <h2 {...{
      "id": "basic-usage"
    }}>{`Basic Usage`}</h2>
    <h3 {...{
      "id": "1-wrap-with-menuprovider"
    }}>{`1. Wrap with MenuProvider`}</h3>
    <p>{`Wrap your `}<inlineCode parentName="p">{`<App/>`}</inlineCode>{` with the `}<inlineCode parentName="p">{`<MenuProvider/>`}</inlineCode>{`, and pass in the `}<inlineCode parentName="p">{`MenuComponent`}</inlineCode>{`.`}</p>
    <pre><code parentName="pre" {...{}}>{`import MenuProvider from 'react-flexible-sliding-menu';
import YourMenuComponent from 'path/to/your/MenuComponent';

<MenuProvider MenuComponent={YourMenuComponent}>
    <App/>
</MenuProvider>
`}</code></pre>
    <h3 {...{
      "id": "2-open-the-menu-using-context"
    }}>{`2. Open the Menu using Context`}</h3>
    <p>{`Now, from anywhere within your `}<inlineCode parentName="p">{`<App/>`}</inlineCode>{` useContext and open the menu.`}</p>
    <pre><code parentName="pre" {...{}}>{`import React, { useContext } from 'react';
import { MenuContext } from 'react-flexible-sliding-menu';

const App = () => {
    const { toggleMenu } = useContext(MenuContext);
    return (
        <div>
            <h1>App</h1>
            <button onClick={toggleMenu} >
                Toggle Menu
            </button>
        </div>
    )
}

`}</code></pre>
    <h2 {...{
      "id": "demo"
    }}>{`Demo`}</h2>
    <p>{`After adding some additional content and styles we will get:`}</p>
    <iframe src="https://codesandbox.io/embed/react-flexible-sliding-menu-dj0yz?fontsize=14&hidenavigation=1&theme=dark" style={{
      "width": "100%",
      "height": "500px",
      "border": "0",
      "borderRadius": "4px",
      "overflow": "hidden"
    }} title="react-flexible-sliding-menu" allow="geolocation; microphone; camera; midi; vr; accelerometer; gyroscope; payment; ambient-light-sensor; encrypted-media; usb" sandbox="allow-modals allow-forms allow-popups allow-scripts allow-same-origin" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      